import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ConsultationsActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar } from  '../../components'

class ConsultationAddParticipantScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    const token       = this.props.user && this.props.user.auth.token ? this.props.user.auth.token : '';
    const practice_id = this.props.context && this.props.context.selectedPractice ? this.props.context.selectedPractice : '';

    if (token && practice_id) {
      this.props.practiceActions.getPracticeStaff(token, practice_id);
    }
  }

  renderAddParticipantSection = (consultation, staff) => {
    if (!consultation || !staff) {
      return null;
    }

    let allCurrentParticipants = {};
    let added_participants     = this.props.consultations
                                 && this.props.consultations.consultationParticipants
                                 && this.props.consultations.consultationParticipants[consultation._id]
                                 ?  this.props.consultations.consultationParticipants[consultation._id] : [];

    allCurrentParticipants[consultation.primary_assignee] = true;
    allCurrentParticipants[consultation.primary_client] = true;

    if (consultation && added_participants && added_participants.length > 0) {
      added_participants.forEach((participant) => {
        allCurrentParticipants[participant.user_id] = true;
      })
    }

    const staffRows = staff.map((member) => {
      const userInfo = member.user_details && member.user_details[0] ? member.user_details[0] : member.user_details[0];

      if (userInfo && userInfo.first_name && !allCurrentParticipants[member.user_id] && !member.front_desk) {
        return <div key={member._id} className="flex-container flex-container-row flex-space-between flex-center-align" style={{ marginTop: 5, marginBottom: 5 }}>
          <span>{ StringUtils.displayName(userInfo) }</span>
          <input  type="submit"
                  value="Add"
                  className="button-default"
                  style={{ paddingTop: 5, paddingBottom: 5 }}
                  onClick={ () => {
                    this.props.consultationsActions.addConsultationParticipant(this.props.user.auth.token, consultation._id, member.user_id, this.successAction);
                  }}
                />
        </div>
      }
    }).filter((memberRow) => { return memberRow });

    let display_rows = staffRows && staffRows.length > 0 ? true : false;

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="basic-container">

        { !display_rows ? null : staffRows }
        {  display_rows ? null : <div style={{ fontSize: 14, color: 'grey', textAlign: 'center', marginTop: 10, marginBottom: 10 }}>There are no applicable users that can be added to this consultation.</div> }
        </div>
      </div>
    </div>
  }

  render() {

    const selectedConsultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    var consultation =  this.props.consultations
                          && this.props.consultations.allConsultations
                          && this.props.consultations.allConsultations[selectedConsultation._id] ? this.props.consultations.allConsultations[selectedConsultation._id] : selectedConsultation;

    const staff = this.props.practice.staff || null;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Add Consultation Participant" />
        { this.renderAddParticipantSection(consultation, staff) }
      </div>
    );
  }

  savePracticeInfoChanges = (practice) => {
    const token = this.props.user.auth.token;
    var updatedPractice = Object.assign({}, practice);
    updatedPractice.name = this.state.name;

    if (practice && token && updatedPractice) {
      this.props.practiceActions.editPracticeInfo(token, updatedPractice, this.successAction);
    }
  }

  successAction = () => {
    NavigationActions.navigateBack();
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    consultations: state.consultations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationAddParticipantScreen)
